import { render, staticRenderFns } from "./AddressSearchResultSingle.vue?vue&type=template&id=49431f2b&"
import script from "./AddressSearchResultSingle.vue?vue&type=script&setup=true&lang=js&"
export * from "./AddressSearchResultSingle.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./AddressSearchResultSingle.vue?vue&type=style&index=0&id=49431f2b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VPagination } from 'vuetify/lib/components/VPagination';
installComponents(component, {VPagination})
